/* The Sleep Co - Memory Collection PDP behaviour */
(function () {
  var root = document.querySelector('.mem');
  if (!root) return;

  /* ---- The weight test ---- */
  var wt = document.getElementById('mem-wt');
  if (wt) {
    var surf = document.getElementById('mem-surf'),
        fill = document.getElementById('mem-surf-fill'),
        body = document.getElementById('mem-body'),
        cap  = document.getElementById('mem-wt-caption'),
        pts  = [].slice.call(root.querySelectorAll('.mem-pt')),
        r1 = document.getElementById('mem-r1'),
        r2 = document.getElementById('mem-r2'),
        r3 = document.getElementById('mem-r3');
    var D = [0, 20, 44, 30, 10, 4], HOT = [217, 162, 99], COLD = [188, 214, 226];
    var lerp = function (a, b, t) { return a + (b - a) * t; };
    var mix = function (a, b, t) {
      return 'rgb(' + Math.round(lerp(a[0], b[0], t)) + ',' +
                      Math.round(lerp(a[1], b[1], t)) + ',' +
                      Math.round(lerp(a[2], b[2], t)) + ')';
    };
    var render = function () {
      var t = wt.value / 100;
      var d = 'M40 230 Q 140 ' + (230 + D[1] * t * 0.4) + ' 246 ' + (230 + D[2] * t) +
              ' Q 330 ' + (230 + D[2] * t * 1.1) + ' 404 ' + (230 + D[3] * t * 1.3) +
              ' Q 500 ' + (230 + D[3] * t) + ' 556 ' + (230 + D[3] * t * 0.7) +
              ' Q 640 ' + (230 + D[4] * t) + ' 690 ' + (230 + D[4] * t * 0.8) +
              ' Q 760 ' + (230 + D[5] * t) + ' 860 230';
      surf.setAttribute('d', d);
      fill.setAttribute('d', d + ' L860 330 L40 330 Z');
      var sizes = [13, 16, 11, 9, 8];
      var sinks = [D[2], D[3] * 1.3, D[3] * 0.7, D[4] * 0.8, D[5]];
      pts.forEach(function (c, i) {
        c.setAttribute('cy', 230 + sinks[i] * t);
        c.setAttribute('r', Math.max(3, sizes[i] * (1 - t * 0.72)));
        c.setAttribute('fill', mix(HOT, COLD, t));
        c.setAttribute('fill-opacity', String(0.95 - t * 0.35));
      });
      body.setAttribute('transform', 'translate(0,' + (t * 16) + ')');
      if (r1) r1.firstChild.textContent = Math.max(0, Math.round(5 - t * 5));
      if (r2) r2.firstChild.textContent = Math.round(38 + t * 54) + '%';
      if (r3) r3.firstChild.textContent = '~' + Math.round(38 - t * 24);
      cap.textContent = t < 0.28 ? 'Firm surface, load concentrated in five places'
                      : t < 0.72 ? 'Medium contour, load beginning to spread'
                      : 'Full memory contour, nothing single carrying you';
    };
    wt.addEventListener('input', render);
    render();
  }

  /* ---- Layer reveal and sticky bar ---- */
  var stack = document.getElementById('mem-stack');
  var bar = document.getElementById('mem-buy');
  var anchor = document.getElementById('mem-feel');

  if ('IntersectionObserver' in window) {
    if (stack) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.2 });
      io.observe(stack);
    }
    if (bar && anchor) {
      var gate = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          bar.classList.toggle('is-on', !e.isIntersecting || e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      gate.observe(anchor);
    }
  } else {
    if (stack) stack.classList.add('is-in');
    if (bar) bar.classList.add('is-on');
  }

  /* ---- Buy bar: keep price in step with the chosen variant ---- */
  var sel = document.getElementById('mem-variant');
  var price = document.getElementById('mem-price');
  var addBtn = document.getElementById('mem-add');
  if (sel && price) {
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      price.textContent = o.getAttribute('data-price') || '';
      if (addBtn) {
        var out = o.getAttribute('data-available') === 'false';
        addBtn.disabled = out;
        addBtn.textContent = out ? 'Sold out' : 'Add to basket';
      }
    });
  }
})();
